// first page index must be 0
export const getFirstResultIndex = (pageSize: number, page: number): number => {
  const output = pageSize * page;
  return output;
};
